import { mapGetters } from 'vuex'
import {
  parseValidations,
  parseValidationSetup,
  phoneRuleIfNotEmpty,
  setValidationRule,
  ValidationMixins,
  Validators,
  validDate,
  validDateBeforeToday,
  zipRuleIfNotEmpty
} from '../../../../lib/validations'
import MainService from '../../../../services/main'
import {TIMEZONE, parseDateTime, now, formatDate} from '../../../../lib/dates'
import {countries, states} from '../../../../lib/utils'
const {required, email, phone} = Validators

const EventBus = window.VueEventBus

const validations = {
  first_name: setValidationRule('fields.first_name', {
    required: {error: 'First name is required.', rule: Validators.requiredIf('first_name_required')}
  }),
  last_name: setValidationRule('fields.last_name', {
    required: {error: 'Last name is required.', rule: Validators.requiredIf('last_name_required')}
  }),
  racer_name: setValidationRule('fields.racer_name', {
    required: {error: 'Racer name is required.', rule: Validators.requiredIf('racer_name_required')}
  }),
  email: setValidationRule('fields.email', {
    required: {error: 'Email is required.', rule: Validators.requiredIf('email_required')},
    email: {error: 'Email is not valid.'},
  }),
  birth_date: setValidationRule('fields.birth_date', {
    required: {error: 'Valid Birth date is required', rule: Validators.requiredIf('birth_date_required')},
    invalidDate: {error: 'Birth date is not valid.', rule: validDate},
    pastDate: {error: 'Birth date can not be a future date.', rule: validDateBeforeToday},
  }),
  phone: setValidationRule('fields.phone', {
    required: {error: 'Phone is required.', rule: Validators.requiredIf('phone_required')},
    phone: {error: 'Invalid phone number.', rule: phoneRuleIfNotEmpty}
  }),

  address: setValidationRule('fields.address', {
    required: {error: 'Address is required.', rule: Validators.requiredIf('address_required')},
  }),
  address2: setValidationRule('fields.address2', {
    required: {error: 'Second Address is required.', rule: Validators.requiredIf('address2_required')},
  }),
  city: setValidationRule('fields.city', {
    required: {error: 'City is required.', rule: Validators.requiredIf('city_required')},
  }),
  state: setValidationRule('fields.state', {
    required: {error: 'State is required.', rule: Validators.requiredIf('state_required')},
  }),
  zip: setValidationRule('fields.zip', {
    required: {error: 'Zip is required.', rule: Validators.requiredIf('zip_required')},
    zip: {error: 'Invalid zip.', rule: zipRuleIfNotEmpty},
  }),
  country: setValidationRule('fields.country', {
    required: {error: 'Zip is required.', rule: Validators.requiredIf('country_required')},
  }),

}
export default {
  name: 're-profile-edit',
  props: {
    profileFormClass: {
      type: [String, Array, Object],
      default: 're-profile-form'
    },
    profileSubmitButtonTitle: {
      type: String,
      default: 'Change'
    },
    successMessageProfile: {
      type: String,
      default: 'Your profile has been updated'
    },
    personalFormClass: {
      type: [String, Array, Object],
      default: 're-personal-form'
    },
    personalBoxTitle: {
      type: String,
      default: 'Personal information'
    },
    personalSuccessMessage: {
      type: String,
      default: 'Personal information has been successfully changed'
    },
    personalSubmitButtonTitle: {
      type: String,
      default: 'Save'
    },
    hasFirstNameInput: {
      type: Boolean,
      default: true,
    },
    firstNameRequired: {
      type: Boolean,
      default: true,
    },
    firstNameLabel: {
      type: String,
      default: 'First Name',
    },
    hasLastNameInput: {
      type: Boolean,
      default: true,
    },
    lastNameRequired: {
      type: Boolean,
      default: true,
    },
    lastNameLabel: {
      type: String,
      default: 'Last Name',
    },
    hasRacerNameInput: {
      type: Boolean,
      default: false
    },
    raceNameRequired: {
      type: Boolean,
      default: true,
    },
    raceNameLabel: {
      type: String,
      default: 'Racer Name',
    },
    hasBirthDateInput: {
      type: Boolean,
      default: true
    },
    birthDateRequired: {
      type: Boolean,
      default: true
    },
    birthDateLabel: {
      type: String,
      default: 'Date of Birth',
    },
    hasEmailInput: {
      type: Boolean,
      default: true
    },
    emailRequired: {
      type: Boolean,
      default: true
    },
    emailLabel: {
      type: String,
      default: 'Email',
    },
    hasPhoneInput: {
      type: Boolean,
      default: true
    },
    phoneRequired: {
      type: Boolean,
      default: true
    },
    phoneLabel: {
      type: String,
      default: 'Mobile Phone'
    },
    hasGenderInput: {
      type: Boolean,
      default: true
    },
    genderLabel: {
      type: String,
      default: 'Gender'
    },
    addressFormClass: {
      type: [String, Array, Object],
      default: 're-address-form'
    },
    addressBoxTitle: {
      type: String,
      default: 'Address information'
    },
    addressSubmitButtonTitle: {
      type: String,
      default: 'Save'
    },
    addressSuccessMessage: {
      type: String,
      default: 'Address has been successfully changed'
    },
    hasAddressInput: {
      type: Boolean,
      default: true
    },
    addressRequired: {
      type: Boolean,
      default: true
    },
    addressLabel: {
      type: String,
      default: 'Address 1'
    },
    hasSecondAddressInput: {
      type: Boolean,
      default: true
    },
    secondAddressRequired: {
      type: Boolean,
      default: true
    },
    secondAddressLabel: {
      type: String,
      default: 'Address 2'
    },
    hasCityInput: {
      type: Boolean,
      default: true
    },
    cityRequired: {
      type: Boolean,
      default: true
    },
    cityLabel: {
      type: String,
      default: 'City'
    },
    hasStateInput: {
      type: Boolean,
      default: true
    },
    stateRequired: {
      type: Boolean,
      default: true
    },
    stateLabel: {
      type: String,
      default: 'State'
    },
    hasZipInput: {
      type: Boolean,
      default: true
    },
    zipRequired: {
      type: Boolean,
      default: true
    },
    zipLabel: {
      type: String,
      default: 'Zip Code'
    },
    hasCountryInput: {
      type: Boolean,
      default: true
    },
    countryRequired: {
      type: Boolean,
      default: true
    },
    countryLabel: {
      type: String,
      default: 'Country'
    },
    passwordBoxTitle: {
      type: String,
      default: 'Change password'
    },
    isPasswordBoxModal: {
      type: Boolean,
      default: false
    },
    passwordBoxClasses: {
      type: [String, Array, Object],
      default: ''
    },
    passwordBoxButtonTitle: {
      type: String,
      default: 'Change'
    },
    passwordBoxButtonClasses: {
      type: [String, Array, Object],
      default: ''
    },
    isSeparateForms: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [ValidationMixins],

  data() {
    return {
      fields: {
        first_name: '',
        first_name_required: true,
        last_name: '',
        last_name_required: true,
        racer_name: null,
        racer_name_required: false,
        email: null,
        email_required: true,
        birth_date: null,
        birth_date_required: true,
        phone: null,
        phone_required: true,
        gender: null,
        gender_required: true,

        address: null,
        address_required: true,
        address2: null,
        address2_required: true,
        city: null,
        city_required: true,
        country: 'US',
        country_required: true,
        state: null,
        state_required: true,
        zip: null,
        zip_required: true,
      },
      personalFormElements: ['fields.first_name', 'fields.last_name', 'fields.email', 'fields.birth_date', 'fields.phone', 'fields.gender'],
      addressFormElements: ['fields.address', 'fields.address2', 'fields.city', 'fields.country', 'fields.state', 'fields.zip'],
      sources: {
        countries,
        states
      },
      maxDateTime: now.toISODate(),
      validations: parseValidationSetup(validations, this),
      resettingPassword: false,
      errorMessagePersonal: null,
      isSuccessPersonal:false,
      errorMessageAddress: null,
      isSuccessAddress:false,
      errorMessageProfile: null,
      isSuccessProfile:false,
      isSuccessPassword:false,
    }
  },

  validations: {
    fields: parseValidations(validations),
    personalGroup: [
      'fields.first_name', 'fields.last_name','fields.racer_name', 'fields.phone', 'fields.email', 'fields.birth_date'
    ],
    addressGroup: [
      'fields.address', 'fields.address2', 'fields.city', 'fields.country', 'fields.state', 'fields.zip'
    ],
  },

  computed: {
    ...mapGetters({
      user: 'authUser',
    }),
    isShowPasswordModal() {
      return this.isPasswordBoxModal && this.resettingPassword
    },
    membershipInfo() {
      const membership = _.first(_.filter(this.loadedMemberships || [], item => /annual/i.test(_.get(item,'type.description', ''))))
      return _.isEmpty(membership) ? null : membership
    },
    membershipName() {
      return _.get(this.membershipInfo || {}, 'type.description', '')
    },
    membershipExpiration() {
      const {expiration = null} = this.membershipInfo || {}
      return expiration ? formatDate(expiration, 'd MMMM yyyy') : ''
    }
  },

  created() {
    const user = this.user
    if (!user) {
      this.$router.push({ name: 'sign-in' })
      return false
    }
    const meta = user.meta
    this.fields = {
      email: user.email,
      email_required: this.emailRequired,
      first_name: user.first_name,
      first_name_required: this.firstNameRequired,
      last_name: user.last_name,
      last_name_required: this.lastNameRequired,
      racer_name: meta.clubspeed_racername || null,
      racer_name_required: this.raceNameRequired,
      gender: meta.gender,
      phone: meta.phone,
      phone_required: this.phoneRequired,
      address: meta.address,
      address_required: this.addressRequired,
      address2: meta.address2,
      address2_required: this.secondAddressRequired,
      city: meta.city,
      city_required: this.cityRequired,
      country: meta.country,
      country_required: this.countryRequired,
      state: meta.state,
      state_required: this.stateRequired,
      zip: meta.zip,
      zip_required: this.zipRequired,
    }

    let birthDate = parseDateTime(meta.birth_date)
    if (birthDate.isValid) {
      birthDate = birthDate.setZone(TIMEZONE)
      this.fields.birth_date = birthDate.toISO()
      this.fields.birth_date_required = this.birthDateRequired
    }
  },

  methods: {
    // ...mapActions(['updateUser']),

    openPasswordModal() {
      this.resettingPassword = true
    },
    closePasswordModal() {
      this.resettingPassword = false
    },
    successResetPassword() {
      this.resettingPassword = false
      this.isSuccessPassword = true
    },
    closeSuccessPasswordModal() {
      this.isSuccessPassword = false
    },

    async updatePersonal() {
      EventBus.$emit('profile.before.update-personal')
      let payload = _.pick(this, this.personalFormElements)
      if (this.withRacerName) {
        payload = {...payload, clubspeed_racername: this.fields.racerName}
      }

      const isSuccess = await this.changeProfile(payload, 'personalGroup')
      if (isSuccess) {
        this.isSuccessPersonal = true
        EventBus.$emit('profile.update-personal')
      }
    },
    async updateAddress() {
      EventBus.$emit('profile.before.update-address')
      const payload = _.pick(this, this.addressFormElements)
      const isSuccess = await this.changeProfile(payload, 'addressGroup')
      if (isSuccess) {
        this.isSuccessAddress = true
        EventBus.$emit('profile.update-address')
      }
    },
    async updateProfile() {
      EventBus.$emit('profile.before.update-profile')
      const fields = [...this.personalFormElements, ...this.addressFormElements]
      let payload = _.pick(this, fields)
      if (this.withRacerName) {
        payload = {...payload, clubspeed_racername: this.fields.racerName}
      }
      const isSuccess = await this.changeProfile(payload)
      if (isSuccess) {
        this.isSuccessProfile = true
        EventBus.$emit('profile.update-profile')
      }
    },

    async changeProfile(payload, validationGroup = false) {
      if (validationGroup) {
        this.$v[validationGroup].$touch()
      } else {
        this.$v.$touch()
      }
      this.formSubmitting = true

      let error = null
      this.setErrorMessage(error, validationGroup)
      const anyError = validationGroup  ? this.$v[validationGroup].$anyError : this.isAnyInvalid
      let data = false
      if (!anyError) {
        EventBus.$emit('profile.before.update', payload)
        try {
          data = await MainService.updateUser(this.user.id, payload)
          this.$store.dispatch('updateUser', { user: data.data })
          this.$emit('success')
          EventBus.$emit('profile.update.success')
        } catch (e) {
          error = MainService.getFirstErrorMessage(e)
          this.setErrorMessage(error, validationGroup)
          this.$emit('error', e)
          EventBus.$emit('profile.update.error', e)
        } finally {
          this.formSubmitting = false
        }
        return data
      } else {
        error = 'Form data is invalidity'
        this.setErrorMessage(error, validationGroup)
      }
    },

    setErrorMessage(error, validationGroup = false) {
      switch (validationGroup) {
        case 'personalGroup':
          this.errorMessagePersonal = error
          break
        case 'addressGroup':
          this.errorMessageAddress = error
          break
        default:
          this.errorMessageProfile = error
      }
    }
  }
}
